import template from './overviewOwner.html';

export const overviewOwnerComponent = {
  name: 'overviewOwner',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    owner: '<',
    columnClass: '<',
  },
};



// WEBPACK FOOTER //
// ./src/app/components/overview/components/owner/overviewOwner.component.js